export function formatMoney(value: number | null): string {
  if (value == null || !Number.isFinite(value)) return '—';
  return new Intl.NumberFormat('ru-RU', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  }).format(value);
}

export function formatLatency(value: number | null): string {
  if (value == null || !Number.isFinite(value)) return '—';
  return `${value.toFixed(value < 10 ? 2 : 1)} ms`;
}

export function formatCapacity(value: number | null): string {
  if (value == null || !Number.isFinite(value)) return '—';
  if (value >= 1000 * 1000) return `${(value / (1000 * 1000)).toFixed(2)} Tbps`;
  if (value >= 1000) return `${(value / 1000).toFixed(value % 1000 === 0 ? 0 : 2)} Gbps`;
  return `${value.toFixed(value % 1 === 0 ? 0 : 2)} Mbps`;
}

export function shorten(text: string, len = 64) {
  if (!text) return '';
  return text.length <= len ? text : `${text.slice(0, len - 1)}…`;
}
